import styled from '@emotion/styled';

import { getColor } from '../common/UICommon';
import { TabletWidth } from '../../global.style';

interface StyleProps {
  isThereText?: boolean;
  variant?: MainButtonVariant;
}

export enum MainButtonVariant {
  Gradient = 'gradient',
  Purple = 'purple',
  Black = 'black',
  Transparent = 'transparent',
  Gray = 'gray',
  White = 'white',
}

interface MainButtonConfig {
  background: string;
  color: string;
}

const getMainButtonConfig = (variant: MainButtonVariant): MainButtonConfig => {
  switch (variant) {
    case MainButtonVariant.Black:
      return {
        background: getColor('BLACK'),
        color: getColor('WHITE'),
      };
    case MainButtonVariant.Gradient:
      return {
        background: `linear-gradient(91.86deg, ${getColor('PURPLE_60')} 0%, ${getColor('VIOLET_100')} 100%)`,
        color: getColor('WHITE'),
      };
    case MainButtonVariant.Transparent:
      return {
        background: getColor('GRAY_BG_TRANSPARENT'),
        color: getColor('WHITE'),
      };
    case MainButtonVariant.Gray:
      return {
        background: getColor('GRAY_80'),
        color: getColor('WHITE'),
      };
    case MainButtonVariant.Purple:
      return {
        background: getColor('PURPLE_60'),
        color: getColor('WHITE'),
      };
    case MainButtonVariant.White:
      return {
        background: getColor('WHITE'),
        color: getColor('GRAY_80'),
      };
  }
};

export const MainButtonHeight = 55;

export const MainButton = styled.button`
  font-family: 'Poppins';
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  border-radius: 100px;
  display: block;
  border: none;
  outline: none;
  height: ${MainButtonHeight}px;
  padding: 0px 32px;
  margin: 0px auto;
  width: ${(props: StyleProps) => (props.isThereText ? '152px' : '100%')};
  background: ${({ variant = MainButtonVariant.Gradient }: StyleProps) => getMainButtonConfig(variant).background};
  color: ${({ variant = MainButtonVariant.Gradient }: StyleProps) => getMainButtonConfig(variant).color};
  cursor: pointer;
  z-index: 1;
  &:disabled {
    background: ${getColor('GRAY_10')};
    color: ${getColor('GRAY_30')};
  }
`;

export const PurpleButton = styled.button`
  font-family: 'Poppins';
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  border-radius: 100px;
  width: 100%;
  border: none;
  outline: none;
  padding: 16px 32px;
  background: ${getColor('PURPLE_100')};
  color: ${getColor('WHITE')};
  cursor: pointer;
  &:disabled {
    background: ${getColor('GRAY_BG')};
    color: ${getColor('BLACK_60')};
  }
`;

export const AnswerButton = styled.button`
  font-family: 'Poppins';
  width: 100%;
  background-color: ${getColor('WHITE')};
  border: 1px solid ${getColor('GRAY_30')};
  border-radius: 8px;
  text-align: left;
  outline: none;
  padding: 24px 16px;
  margin-bottom: 16px;
  color: ${getColor('GRAY_70')};
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  gap: 12px;
  align-items: center;
  &.active {
    border: 1.5px solid ${getColor('PURPLE_100')};
    padding: 15px;
  }

  &:hover {
    border: 1px solid ${getColor('GRAY_70')};
    background-color: ${getColor('LIGHT_CREAM')};
  }

  @media (max-width: ${TabletWidth}px) {
    padding: 16px;
  }
`;

export const OnlyTextButton = styled.button`
  font-family: 'Poppins';
  color: ${getColor('PURPLE_100')};
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  background-color: transparent;
  outline: none;
  padding: 0;
  border: none;
  cursor: pointer;
`;

export const ButtonIcon = styled.button`
  padding: 0;
  background-color: transparent;
  outline: none;
  border: none;
  margin-left: -4px;
  cursor: pointer;
`;

export const BlackButton = styled.button`
  font-family: 'Poppins';
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;

  padding: 14px, 32px, 14px, 32px;
  background-color: ${getColor('GRAY_80')};
  color: ${getColor('WHITE')};
  width: 100%;
  cursor: pointer;
  border-radius: 4px;
  border-color: transparent;
  &:disabled {
    background-color: ${getColor('GRAY_10')};
    color: ${getColor('GRAY_50')};
  }
`;
